var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4577 8.39337C16.0626 8.39337 15.5393 8.38462 14.8878 8.38462C13.2989 8.38462 11.9924 7.0695 11.9924 5.46563V2.65162C11.9924 2.43025 11.8156 2.25 11.5964 2.25H6.96817C4.80827 2.25 3.0625 4.02275 3.0625 6.19537V15.6235C3.0625 17.9029 4.89144 19.75 7.14838 19.75H14.0405C16.1926 19.75 17.9375 17.9886 17.9375 15.8142V8.78713C17.9375 8.56488 17.7616 8.3855 17.5416 8.38637C17.1716 8.389 16.728 8.39337 16.4577 8.39337Z",
    fill: "#008F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0735 2.74639C13.8119 2.47426 13.3551 2.66151 13.3551 3.03864V5.34601C13.3551 6.31376 14.1522 7.11001 15.12 7.11001C15.7299 7.11701 16.5769 7.11876 17.2961 7.11701C17.6645 7.11614 17.8517 6.67601 17.5962 6.41001C16.6731 5.45014 15.0202 3.72989 14.0735 2.74639Z",
    fill: "#006464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6158 13.5312C12.9754 13.5312 13.2676 13.8234 13.2676 14.1831C13.2676 14.5427 12.9754 14.8341 12.6158 14.8341H7.85226C7.49263 14.8341 7.20126 14.5427 7.20126 14.1831C7.20126 13.8234 7.49263 13.5312 7.85226 13.5312H12.6158ZM10.814 9.16127C11.1737 9.16127 11.4659 9.45352 11.4659 9.81315C11.4659 10.1728 11.1737 10.4641 10.814 10.4641H7.85217C7.49255 10.4641 7.20117 10.1728 7.20117 9.81315C7.20117 9.45352 7.49255 9.16127 7.85217 9.16127H10.814Z",
    fill: "#FBFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperGreen);
export default __webpack_public_path__ + "static/media/PaperGreen.1598bedb.svg";
export { ForwardRef as ReactComponent };